import { Tooltip } from '@mui/material'
import { EllipsisText } from './EllipsisWithTooltip.styles'

interface EllipsisWithTooltipProps {
  value?: string | null
}

const EllipsisWithTooltip = ({ value }: EllipsisWithTooltipProps) => {
  const displayValue = value?.trim() ? value : '-'

  if (displayValue === '-') {
    return <>{displayValue}</>
  }

  return (
    <Tooltip title={displayValue}>
      <EllipsisText component="span">{displayValue}</EllipsisText>
    </Tooltip>
  )
}

export default EllipsisWithTooltip
